<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">收支类别</span>
            <span class="bar-tools">
                <input type="text" class="h-input h-input-s" style="width:180px" placeholder="请输入编码或名称"
                       v-model="keyword" @keyup.enter="loadList">
                <Button size="s" @click="loadList">查询</Button>
                <Button color="primary" size="s" @click="add">新增</Button>
            </span>
        </div>
        <div class="h-panel-body">
            <Tabs :datas="tabDatas" v-model="ioType" @change="loadList" class-name="h-tabs-card"></Tabs>
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:140px">{{isIncome ? '收入编码' : '支出编码'}}</th>
                    <th style="width:160px">{{isIncome ? '收入名称' : '支出名称'}}</th>
                    <th style="min-width:200px">关联科目</th>
                    <th style="width:120px">关联凭证字</th>
                    <th style="min-width:280px">智能匹配摘要关键字</th>
                    <th style="width:120px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td>{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.subjectCode}} {{item.subjectName}}</td>
                    <td>{{item.voucherWord}}</td>
                    <td class="wrap-cell">{{item.keywords}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="6" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>
            <div class="padding-15 text-gray">
                提示：当日记账的摘要中包含对应关键字时，可自动匹配带出收支类别。
            </div>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : '新增'}}{{isIncome ? '收入' : '支出'}}类别</div>
            <Form ref="form" v-width="450" :labelWidth="130" :model="form" :rules="validationRules">
                <FormItem label="编码" prop="code"><input type="text" v-model="form.code"></FormItem>
                <FormItem label="名称" prop="name"><input type="text" v-model="form.name"></FormItem>
                <FormItem label="关联科目">
                    <Select v-model="form.subjectId" :datas="subjectOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="凭证字">
                    <Select v-model="form.voucherWordId" :datas="wordOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="智能匹配摘要关键字">
                    <textarea rows="3" v-model="form.keywords" placeholder="多个关键字用逗号分隔，如：利息,手续费,餐费"></textarea>
                </FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit" :loading="loading">{{form.id ? '更新' : '保存'}}</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
const emptyForm = {
    id: null, code: '', name: '', ioType: 1,
    subjectId: null, voucherWordId: null, keywords: ''
};

export default {
    name: 'CashierIoType',
    data() {
        return {
            datas: [],
            keyword: '',
            ioType: '1',
            tabDatas: { '1': '收入', '2': '支出' },
            showForm: false,
            loading: false,
            form: Object.assign({}, emptyForm),
            subjectOptions: [],
            wordOptions: [],
            validationRules: { required: ['code', 'name'] }
        };
    },
    computed: {
        isIncome() { return this.ioType === '1'; }
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        loadOptions() {
            this.$api.funds.journal.options().then(({ data }) => {
                this.subjectOptions = (data.subjects || []).map(s => ({ id: s.id, name: s.code ? `${s.code} ${s.name}` : s.name }));
                this.wordOptions = (data.voucherWords || []).map(w => ({ id: w.id, name: w.word }));
            });
        },
        loadList() {
            this.$api.funds.ioType.list({ ioType: this.ioType, keyword: this.keyword }).then(({ data }) => {
                this.datas = data || [];
            });
        },
        add() {
            this.form = Object.assign({}, emptyForm, { ioType: Number(this.ioType) });
            this.showForm = true;
        },
        edit(item) { this.form = Object.assign({}, emptyForm, item); this.showForm = true; },
        submit() {
            if (!this.$refs.form.valid().result) return;
            this.loading = true;
            this.$api.funds.ioType[this.form.id ? 'update' : 'save'](this.form).then(() => {
                this.loading = false;
                this.showForm = false;
                this.loadList();
                this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除「${item.name}」?`).then(() => {
                this.$api.funds.ioType.delete(item.id).then(() => this.loadList());
            });
        }
    },
    mounted() {
        this.loadOptions();
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .bar-tools {
        margin-left: 20px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        .wrap-cell { white-space: normal; }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }
</style>
